import Guardian from "../animations/guardians/Guardian";
import GuardianElf from "../animations/guardians/GuardianElf";
import GuardianElfFemale from "../animations/guardians/GuardianElfFemale";
import GuardianKnight from "../animations/guardians/GuardianKnight";
import GuardianKnightFemale from "../animations/guardians/GuardianKnightFemale";
import GuardianRanger from "../animations/guardians/GuardianRanger";
import GuardianRangerFemale from "../animations/guardians/GuardianRangerFemale";
import GuardianWarrior from "../animations/guardians/GuardianWarrior";
import GuardianWitch from "../animations/guardians/GuardianWitch";
import GuardianWizard from "../animations/guardians/GuardianWizard";
import common from "../common";
import frag from "../shaders/pick.frag";
import GelButton from "../ui/gel/GelButton";
import GelHackButton from "../ui/gel/GelHackButton";
import GelScene from "../ui/gel/GelScene";

export default class UserScene extends GelScene {
    constructor() {
        super();

        this.signals.deleteUser = new P3.utils.MiniSignal();

        this._userSlot1Button = null;
        this._userSlot2Button = null;
        this._userSlot3Button = null;
        this._userSlotMask = null;
        this._frame = 0;

        this._slotOverDelay = null;
        this._slotTexture = null;
    }

    init() {
        super.init();

        const bg = new PIXI.Sprite(P3.assets.texture("ui_results_bg1"));
        bg.width = common.STAGE_WIDTH;
        this.addChild(bg);

        this.initTitle("Choose Game");

        this.initBackButton(1);
        this.initMuteButton(2);
        this.initSettingsButton(3);

        this._userSlot1Button = this.createUserSlot(0);
        this._userSlot1Button.position.set(common.STAGE_WIDTH * 0.5 - 280, 420);
        this._userSlot1Button.visible = false;
        this.addChild(this._userSlot1Button);

        this._userSlot2Button = this.createUserSlot(1);
        this._userSlot2Button.position.set(common.STAGE_WIDTH * 0.5, 420);
        this._userSlot2Button.visible = false;
        this.addChild(this._userSlot2Button);

        this._userSlot3Button = this.createUserSlot(2);
        this._userSlot3Button.position.set(common.STAGE_WIDTH * 0.5 + 280, 420);
        this._userSlot3Button.visible = false;
        this.addChild(this._userSlot3Button);



        // stats
        common.gmi.setStatsScreen && common.gmi.setStatsScreen("saveslots");
    }

    destroy() {
        this.onSlotMouseOut();

        super.destroy();
    }

    appear() {
        super.appear();

        P3.audio.playVO("vo_queen_04b", 1, true);
    }

    animateIn() {
        if (this.parent === null) return;

        let to = this._userSlot1Button.y;

        this._userSlot1Button.y += 120;
        this._userSlot1Button.alpha = 0;

        this._userSlot1Button.button.enabled = true;
        this._userSlot1Button.dummyButton.enabled = true;

        new P3.utils.TWEEN.Tween(this._userSlot1Button, this._tweens)
            .to({y: to, alpha: 1}, 440)
            .easing(P3.utils.TWEEN.Easing.Cubic.Out)
            .delay(200)
            .onStart(() => {
                this._userSlot1Button.visible = true;
            })
            .start();

        to = this._userSlot2Button.y;
        this._userSlot2Button.y += 120;
        this._userSlot2Button.alpha = 0;

        this._userSlot2Button.button.enabled = true;
        this._userSlot2Button.dummyButton.enabled = true;

        new P3.utils.TWEEN.Tween(this._userSlot2Button, this._tweens)
            .to({y: to, alpha: 1}, 440)
            .easing(P3.utils.TWEEN.Easing.Cubic.Out)
            .delay(280)
            .onStart(() => {
                this._userSlot2Button.visible = true;
            })
            .start();

        to = this._userSlot3Button.y;
        this._userSlot3Button.y += 120;
        this._userSlot3Button.alpha = 0;

        this._userSlot3Button.button.enabled = true;
        this._userSlot3Button.dummyButton.enabled = true;

        new P3.utils.TWEEN.Tween(this._userSlot3Button, this._tweens)
            .to({y: to, alpha: 1}, 440)
            .easing(P3.utils.TWEEN.Easing.Cubic.Out)
            .delay(340)
            .onStart(() => {
                this._userSlot3Button.visible = true;
            })
            .start();
    }

    show() {
        super.show();

        this._userSlot1Button.interactive = true;
        this._userSlot2Button.interactive = true;
        this._userSlot3Button.interactive = true;

        this._userSlot1Button.button.enabled = true;
        this._userSlot2Button.button.enabled = true;
        this._userSlot3Button.button.enabled = true;

        this._userSlot1Button.deleteButton.enabled = true;
        this._userSlot2Button.deleteButton.enabled = true;
        this._userSlot3Button.deleteButton.enabled = true;
    }

    hide() {
        super.hide();

        this._userSlot1Button.interactive = false;
        this._userSlot2Button.interactive = false;
        this._userSlot3Button.interactive = false;

        this._userSlot1Button.button.enabled = false;
        this._userSlot2Button.button.enabled = false;
        this._userSlot3Button.button.enabled = false;

        this._userSlot1Button.deleteButton.enabled = false;
        this._userSlot2Button.deleteButton.enabled = false;
        this._userSlot3Button.deleteButton.enabled = false;
    }

    update() {
        super.update();
        const dt = window.dt;

        const settings = common.gmi.getAllSettings();

        const rate = 3;
        const arr = [this._userSlot1Button, this._userSlot2Button, this._userSlot3Button];
        if (this._frame++ % rate === 0) {
            for (let i = 0; i < arr.length; ++i) {
                const slot = arr[i];
                if (settings.motion) {
                    slot.portrait && slot.portrait.update(dt * rate * 0.5);
                }
            }
        }
    }

    deleteUser(id) {
        common.save.resetUserData(id);

        const slots = [this._userSlot1Button, this._userSlot2Button, this._userSlot3Button];
        const slot = slots[id];
        slot.fill.tint = 0xE3E4D7;

        slot.label.visible = true;

        slot.deleteButton.interactive = false;
        slot.deleteButton.visible = false;

        slot.portrait.destroy();
        slot.portrait = null;

        slot.progress.visible = false;
    }

    createUserSlot(id) {
        const slot = new PIXI.Container();

        const user = common.save.getUserData(id);

        const width = 240;
        const height = 310;

        slot.image = new PIXI.mesh.NineSlicePlane(P3.assets.texture("ui_card_bg_9slice"), 60, 60, 60, 60);
        slot.image.width = width;
        slot.image.height = height;
        slot.image.pivot.x = slot.image.width * 0.5;
        slot.image.pivot.y = slot.image.height * 0.5;
        slot.addChild(slot.image);

        // we generate this texture to use for the dummy slot
        if (!this._slotTexture) {
            this._slotTexture = common.renderer.generateTexture(slot.image);
        }

        if (common.renderer instanceof PIXI.WebGLRenderer) {
            slot.fill = new PIXI.mesh.NineSlicePlane(P3.assets.texture("ui_card_fill_9slice"), 10, 10, 10, 10);
            slot.fill.width = width;
            slot.fill.height = height;
            slot.fill.pivot.set(slot.fill.width * 0.5, slot.fill.height * 0.5);
            slot.fill.scale.set(0.86);
            slot.fill.tint = user.finishedTraining ? 0x9D1834 : 0xE3E4D7;
            slot.addChild(slot.fill);
        } else {
            slot.fill = new PIXI.Graphics();
            slot.fill.beginFill(user.finishedTraining ? 0x9D1834 : 0xE3E4D7, 1);
            slot.fill.drawRect(-width * 0.5, -height * 0.5, width, height);
            slot.fill.endFill();
            slot.fill.scale.set(0.86);
            slot.addChild(slot.fill);
        }

        if (!this._userSlotMask) {
            const rgb = new Float32Array(3);
            rgb[0] = 1;
            rgb[1] = 1;
            rgb[2] = 1;

            slot.fill.filters = [new PIXI.Filter(null, frag, {
                pickColor: {type: "vec3", value: rgb}})];

            this._userSlotMask = common.renderer.generateTexture(slot.fill);

            slot.fill.filters = null;
        }

        if (user.finishedTraining) {
            const characters = P3.utils.objectToArray(P3.assets.json("characters"));
            const character = characters.filter(x => x.skin === user.class)[0];

            const golden = common.save.isWeeklyChallengeComplete(common.userId);

            switch (character.type) {
                default :
                case Guardian.TYPE_KNIGHT : {
                    slot.portrait = new GuardianKnight(golden);
                    break;
                }
                case Guardian.TYPE_KNIGHT_FEMALE : {
                    slot.portrait = new GuardianKnightFemale(golden);
                    break;
                }
                case Guardian.TYPE_WARRIOR : {
                    slot.portrait = new GuardianWarrior(golden);
                    break;
                }
                case Guardian.TYPE_ELF : {
                    slot.portrait = new GuardianElf(golden);
                    break;
                }
                case Guardian.TYPE_ELF_FEMALE : {
                    slot.portrait = new GuardianElfFemale(golden);
                    break;
                }
                case Guardian.TYPE_RANGER : {
                    slot.portrait = new GuardianRanger(golden);
                    break;
                }
                case Guardian.TYPE_RANGER_FEMALE : {
                    slot.portrait = new GuardianRangerFemale(golden);
                    break;
                }
                case Guardian.TYPE_WIZARD : {
                    slot.portrait = new GuardianWizard(golden);
                    break;
                }
                case Guardian.TYPE_WITCH : {
                    slot.portrait = new GuardianWitch(golden);
                    break;
                }
            }

            slot.portrait.position.set(-12, 262);
            slot.portrait.scale.set(0.4);
            slot.portrait.init(user.class);
            slot.addChild(slot.portrait);

            slot.portrait.playIdleAnim();
            slot.portrait.update(0);

            // equip guardian
            for (const i in user.equipment) {
                if (user.equipment.hasOwnProperty(i)) {
                    const type = user.equipment[i];
                    if (i !== "pet")
                        slot.portrait.setItem(i, type);
                }
            }

            let k = id * 10;
            while (--k > 0) slot.portrait.update(Math.random());

            if (common.renderer instanceof PIXI.WebGLRenderer) {
                slot.portrait.mask = new PIXI.Sprite(this._userSlotMask);
                slot.portrait.mask.scale.set(slot.fill.scale.x);
                slot.portrait.mask.anchor.set(0.5);
                slot.addChild(slot.portrait.mask);
            } else {
                slot.portrait.mask = new PIXI.Graphics();
                slot.portrait.mask.beginFill(0xFF0000);
                slot.portrait.mask.drawRect(-slot.fill.width * 0.5, -slot.fill.height * 0.5, slot.fill.width, slot.fill.height);
                slot.portrait.mask.endFill();
                slot.addChild(slot.portrait.mask);
            }
        }

        slot.label = new PIXI.extras.BitmapText("Create\nNew Game", {font: "36px BBC Reith Sans", align: "center"});
        slot.label.position.set(0, -12);
        slot.label.anchor.set(0.5);
        slot.label.tint = 0x2B365A;
        slot.label.maxWidth = 200;
        slot.label.visible = !user.finishedTraining;
        slot.addChild(slot.label);

        slot.dummyButton = GelHackButton.create(this._slotTexture);
        slot.dummyButton.id = id;
        slot.dummyButton.alpha = 0;
        slot.dummyButton.tabIndex = GelButton.TAB_INDEX_LEVEL_2 + id;
        slot.dummyButton.animate = false;
        slot.dummyButton.enabled = false;
        slot.dummyButton.signals.click.add((button) => this.onUserSlotButtonClick(button));
        slot.dummyButton.signals.over.add((button) => this.onSlotMouseOver(button));
        slot.dummyButton.signals.out.add((button) => this.onSlotMouseOut(button));
        slot.addChild(slot.dummyButton);

        slot.button = GelHackButton.create(
            P3.assets.texture("btn_large_normal"),
            P3.assets.texture("btn_large_over"),
            P3.assets.texture("btn_large_down"),
            P3.assets.texture("btn_icon_play_large_nongel")
        );
        slot.button.id = id;
        slot.button.position.set(0, 150);
        slot.button.tabIndex = GelButton.TAB_INDEX_NONE;
        slot.button.enabled = false;
        slot.button.overSoundName = "sfx_btn_rollover_00";
        slot.button.clickSoundName = "sfx_btn_press_00";
        slot.button.voSoundName = "vo_queen_103a";
        slot.button.signals.click.add((button) => this.onUserSlotButtonClick(button));
        slot.addChild(slot.button);

        slot.deleteButton = GelHackButton.create(
            P3.assets.texture("btn_large_normal"),
            P3.assets.texture("btn_large_over"),
            P3.assets.texture("btn_large_down"),
            P3.assets.texture("ui_btn_large_icon_trash")
        );
        slot.deleteButton.id = id;
        slot.deleteButton.position.set(90, -132);
        slot.deleteButton.overSoundName = "sfx_btn_rollover_00";
        slot.deleteButton.clickSoundName = "sfx_btn_press_00";
        slot.deleteButton.signals.click.add((button) => this.onUserDeleteButtonClick(button));
        slot.deleteButton.visible = user.finishedTraining;
        slot.addChild(slot.deleteButton);

        slot.progress = this.createProgressBar(id);
        slot.progress.position.set(0, 240);
        slot.progress.visible = user.finishedTraining;
        slot.addChild(slot.progress);

        return slot;
    }

    createProgressBar(userId) {
        const user = common.save.getUserData(userId);
        const progression = P3.utils.objectToArray(common.config.game.level_progression);
        const target = progression[Math.min(progression.length - 1, user.level)];
        const to = user.xp / target;

        const progress = new PIXI.Sprite(P3.assets.texture("progress/ui_xp_bg_small"));
        progress.anchor.set(0.5);

        progress.fill = new PIXI.Sprite(P3.assets.texture("progress/ui_xp_fill_small"));
        progress.fill.anchor.set(0.5);
        progress.addChild(progress.fill);

        const width = progress.fill.texture.width;
        const height = progress.fill.texture.height;

        progress.fill.mask = new PIXI.Graphics();
        progress.fill.mask.position.set(-width * 0.5, 0);
        progress.fill.mask.scale.x = to;
        progress.fill.mask.beginFill(0xFF0000, 1);
        progress.fill.mask.drawRect(0, -height * 0.5, width, height);
        progress.fill.mask.endFill();
        progress.fill.addChild(progress.fill.mask);

        progress.plaque = new PIXI.Sprite(P3.assets.texture("progress/ui_xp_count_bg_small"));
        progress.plaque.position.set(-progress.texture.width * 0.5 - 40, 0);
        progress.plaque.anchor.set(0.5);
        progress.addChild(progress.plaque);

        progress.icon = new PIXI.Sprite(P3.assets.texture("progress/ui_xp_loot_small"));
        progress.icon.position.set(progress.texture.width * 0.5 + 36, 0);
        progress.icon.anchor.set(0.5);
        progress.addChild(progress.icon);

        let xp = Math.round(user.totalXp);
        let size = 30;
        if (xp > common.config.game.xp_cap) {
            xp = Math.round(common.config.game.xp_cap) + "+";
            size = 26;
        }

        progress.xpLabel = new PIXI.extras.BitmapText(xp + "", {font: size + "px BBC Reith Sans", align: "center"});
        progress.xpLabel.position.set(0, 14);
        progress.xpLabel.anchor.set(0.5);
        progress.xpLabel.tint = 0x390307;
        progress.plaque.addChild(progress.xpLabel);

        return progress;
    }

    onUserSlotButtonClick(button) {
        this._userSlot1Button.interactive = false;
        this._userSlot2Button.interactive = false;
        this._userSlot3Button.interactive = false;

        this._userSlot1Button.button.enabled = false;
        this._userSlot2Button.button.enabled = false;
        this._userSlot3Button.button.enabled = false;

        this._userSlot1Button.deleteButton.enabled = false;
        this._userSlot2Button.deleteButton.enabled = false;
        this._userSlot3Button.deleteButton.enabled = false;

        common.userId = button.id;

        // tracking
        common.gmi.sendStatsEvent("saveslot", "click");

        this.signals.next.dispatch(this);
    }

    onUserDeleteButtonClick(button) {
        this.signals.deleteUser.dispatch(this, button.id);
    }

    onSlotMouseOver(event) {
        this._slotOverDelay = P3.utils.delayg(this._tweens, 3, () => {
            P3.audio.playVO("vo_queen_112a");
        });
    }

    onSlotMouseOut(event) {
        if (this._slotOverDelay) {
            this._slotOverDelay.stop();
            this._slotOverDelay = null;
        }
    }
}